import { render, staticRenderFns } from "./CourseReviewDetails.vue?vue&type=template&id=bb8730d2&scoped=true"
import script from "./CourseReviewDetails.vue?vue&type=script&lang=js"
export * from "./CourseReviewDetails.vue?vue&type=script&lang=js"
import style0 from "./CourseReviewDetails.vue?vue&type=style&index=0&id=bb8730d2&prod&lang=less"
import style1 from "./CourseReviewDetails.vue?vue&type=style&index=1&id=bb8730d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8730d2",
  null
  
)

export default component.exports